var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingwentwrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26760",
    "data-name": "Group 26760",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.268,
    height: 108.727,
    viewBox: "0 0 111.268 108.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12007",
    "data-name": "Rectangle 12007",
    width: 111.268,
    height: 108.727,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26759",
    "data-name": "Group 26759",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23413",
    "data-name": "Path 23413",
    d: "M125.227,110.977a3.837,3.837,0,0,1-.587.615,1.1,1.1,0,0,1-1.7-.255,1.975,1.975,0,0,1,.01-1.638,1.111,1.111,0,0,1,1.7-.228,3.521,3.521,0,0,1,.57.636Z",
    transform: "translate(-13.959 -12.414)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23414",
    "data-name": "Path 23414",
    d: "M70.29,101.22H89.521q5.6,0,11.194,0c1.291,0,1.851.393,1.867,1.288s-.57,1.345-1.815,1.345H13.061c-.253,0-.6.09-.742-.04-.407-.383-1.009-.856-1.007-1.291s.594-.931,1.035-1.253c.238-.175.7-.05,1.064-.05H43.886C33.175,95.934,26.557,87.752,24.857,76.2c-1.7-11.573,1.929-21.558,10.777-29.259a32.306,32.306,0,0,1,47.283,5.043,32.5,32.5,0,0,1,1.6,36.45A34.333,34.333,0,0,1,70.29,101.22M56.873,41.594A29.813,29.813,0,1,0,86.7,71.446,29.786,29.786,0,0,0,56.873,41.594",
    transform: "translate(-1.286 -4.424)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23415",
    "data-name": "Path 23415",
    d: "M61.2,19.207c-1.714,3.133-3.326,6.076-4.935,9.023-1.04,1.9-2.1,3.8-3.1,5.723a1.944,1.944,0,0,1-1.453,1.13c-.8.164-1.579.472-2.51.763.147-.354.228-.61.354-.842q4.539-8.336,9.081-16.67a2.736,2.736,0,0,1,5.128-.032q4.559,8.386,9.138,16.761c.1.186.182.384.359.766-1.229-.37-2.32-.653-3.369-1.047-.276-.1-.453-.533-.622-.841q-3.7-6.755-7.382-13.519c-.187-.344-.386-.681-.691-1.215",
    transform: "translate(-5.595 -1.88)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23416",
    "data-name": "Path 23416",
    d: "M23.045,84.337c.331,1.129.667,2.11.886,3.117a1.781,1.781,0,0,1-.264,1.087c-1.782,3.312-3.59,6.612-5.388,9.916-.187.344-.358.7-.62,1.207.487.026.858.061,1.229.061,3.622,0,7.244.031,10.865-.018a2.359,2.359,0,0,1,2.058.889,13.414,13.414,0,0,0,1.619,1.432c-.05.092-.1.185-.148.278a6.309,6.309,0,0,1-.768.093c-4.816.006-9.633.018-14.449,0-2.717-.011-3.883-1.945-2.6-4.309q3.515-6.488,7.069-12.954c.13-.24.3-.462.513-.8",
    transform: "translate(-1.699 -9.589)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23417",
    "data-name": "Path 23417",
    d: "M89.72,102.33c.817-.862,1.493-1.651,2.259-2.34a1.811,1.811,0,0,1,1.109-.245c3.694-.017,7.388-.01,11.082-.01h1.317c-.245-.508-.4-.861-.581-1.2-1.746-3.209-3.474-6.428-5.264-9.614A2.316,2.316,0,0,1,99.4,86.7a20.267,20.267,0,0,0,.66-2.306,4.38,4.38,0,0,1,.463.571c2.412,4.412,4.83,8.82,7.216,13.246,1.178,2.187.021,4.169-2.467,4.188-4.925.036-9.851.012-14.776.009-.206,0-.411-.04-.777-.079",
    transform: "translate(-10.201 -9.596)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23418",
    "data-name": "Path 23418",
    d: "M118.2,109.219c.288,0,.576,0,.864,0a1.241,1.241,0,0,1,1.377,1.328,1.268,1.268,0,0,1-1.421,1.3q-.864.013-1.728,0a1.262,1.262,0,0,1-1.427-1.287c-.015-.914.565-1.348,1.47-1.344.288,0,.576,0,.864,0",
    transform: "translate(-13.174 -12.418)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23419",
    "data-name": "Path 23419",
    d: "M6.84,109.225c1.631-.009,2.271.377,2.241,1.341-.028.912-.667,1.284-2.209,1.284-.36,0-.721.016-1.08-.008a1.25,1.25,0,0,1-1.309-1.3,1.223,1.223,0,0,1,1.276-1.316c.359-.022.721,0,1.08,0",
    transform: "translate(-0.51 -12.418)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23420",
    "data-name": "Path 23420",
    d: "M2.609,110.558a1.251,1.251,0,0,1-1.34,1.271,1.293,1.293,0,1,1,.054-2.586,1.242,1.242,0,0,1,1.286,1.315",
    transform: "translate(0 -12.421)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23421",
    "data-name": "Path 23421",
    d: "M63.611,117.815v1.327c1.114,0,2.218,0,3.322,0,.869,0,1.74-.021,2.606.033a1.234,1.234,0,0,1,1.266,1.348,1.279,1.279,0,0,1-1.248,1.273,5.544,5.544,0,0,1-.759.021H53.589a5.7,5.7,0,0,1-.651-.013,1.291,1.291,0,0,1-1.3-1.334,1.238,1.238,0,0,1,1.317-1.3c1.23-.041,2.462-.021,3.693-.027.466,0,.932,0,1.482,0v-1.327H56.912c-2.969,0-5.939-.005-8.908,0-.9,0-1.594-.266-1.666-1.285-.06-.846.589-1.365,1.708-1.366q12.82-.011,25.639,0c1.143,0,1.751.476,1.763,1.32s-.581,1.321-1.735,1.326c-2.934.012-5.866,0-8.8,0h-1.3",
    transform: "translate(-5.268 -13.094)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23422",
    "data-name": "Path 23422",
    d: "M84.747,117.8c-.9,0-1.805.017-2.708-.005A1.307,1.307,0,0,1,82,115.184c1.768-.05,3.538-.043,5.306-.005a1.314,1.314,0,1,1-.064,2.626c-.83.012-1.661,0-2.491,0v0",
    transform: "translate(-9.177 -13.093)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23423",
    "data-name": "Path 23423",
    d: "M39.839,117.807c-.867,0-1.733.007-2.6,0a1.234,1.234,0,0,1-1.366-1.238,1.255,1.255,0,0,1,1.339-1.388c1.732-.042,3.466-.037,5.2,0a1.321,1.321,0,1,1-.081,2.634c-.83,0-1.661,0-2.491,0v0",
    transform: "translate(-4.079 -13.093)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23424",
    "data-name": "Path 23424",
    d: "M61.9,53.126c1.3,0,2.607-.02,3.91,0a2.726,2.726,0,0,1,2.9,3.315Q67.562,68.6,66.438,80.766A2.718,2.718,0,0,1,63.532,83.6c-1.158.035-2.319.041-3.475-.01a2.617,2.617,0,0,1-2.717-2.553q-1.013-10.645-1.992-21.294c-.1-1.118-.2-2.235-.317-3.351a2.7,2.7,0,0,1,2.85-3.261c1.339-.031,2.679-.006,4.019-.006m1.858,27.765c.787-8.41,1.562-16.685,2.342-25.021H57.647c.788,8.4,1.567,16.7,2.347,25.021Z",
    transform: "translate(-6.255 -6.039)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23425",
    "data-name": "Path 23425",
    d: "M62.313,90.548A3.8,3.8,0,0,1,66.2,94.469a3.947,3.947,0,1,1-3.886-3.921m-.005,2.636c-.815.054-1.324.452-1.351,1.268a1.294,1.294,0,1,0,2.586.088,1.245,1.245,0,0,0-1.236-1.356",
    transform: "translate(-6.629 -10.295)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23426",
    "data-name": "Path 23426",
    d: "M121.95,33.671a1.293,1.293,0,1,1-1.282-1.28,1.3,1.3,0,0,1,1.282,1.28m-1.287-.538a.554.554,0,0,0-.555.558.544.544,0,0,0,.527.552.555.555,0,1,0,.027-1.111",
    transform: "translate(-13.572 -3.683)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23427",
    "data-name": "Path 23427",
    d: "M20.032,5.847a1.293,1.293,0,1,1-1.282-1.279,1.3,1.3,0,0,1,1.282,1.279M18.745,5.31a.554.554,0,0,0-.555.558.544.544,0,0,0,.527.552.555.555,0,1,0,.027-1.111",
    transform: "translate(-1.984 -0.519)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23428",
    "data-name": "Path 23428",
    d: "M108.26,3.115a1.293,1.293,0,1,1-1.282-1.279,1.3,1.3,0,0,1,1.282,1.279m-1.287-.537a.554.554,0,0,0-.555.558.544.544,0,0,0,.527.552.555.555,0,1,0,.027-1.111",
    transform: "translate(-12.015 -0.209)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23429",
    "data-name": "Path 23429",
    d: "M40.8,22.972a1.962,1.962,0,1,1-1.944-1.941A1.969,1.969,0,0,1,40.8,22.972m-1.952-.815A.841.841,0,0,0,38,23a.826.826,0,0,0,.8.837.852.852,0,0,0,.875-.82.861.861,0,0,0-.833-.864",
    transform: "translate(-4.192 -2.391)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23430",
    "data-name": "Path 23430",
    d: "M84.867,16.222a1.962,1.962,0,1,1-1.944-1.941,1.969,1.969,0,0,1,1.944,1.941m-1.952-.815a.841.841,0,0,0-.842.847.826.826,0,0,0,.8.837.852.852,0,0,0,.875-.82.861.861,0,0,0-.833-.864",
    transform: "translate(-9.203 -1.624)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23431",
    "data-name": "Path 23431",
    d: "M105.763,44.626h-3.817a.222.222,0,0,1,0-.443h3.817a.222.222,0,0,1,0,.443",
    transform: "translate(-11.566 -5.024)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23432",
    "data-name": "Path 23432",
    d: "M105,46.025a.22.22,0,0,1-.186-.1l-2.062-3.212a.221.221,0,0,1,.372-.239l2.062,3.212a.221.221,0,0,1-.066.306.217.217,0,0,1-.12.035",
    transform: "translate(-11.679 -4.818)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23433",
    "data-name": "Path 23433",
    d: "M102.936,46.025a.217.217,0,0,1-.12-.035.221.221,0,0,1-.066-.306l2.062-3.212a.221.221,0,1,1,.372.239l-2.062,3.212a.22.22,0,0,1-.186.1",
    transform: "translate(-11.679 -4.817)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23434",
    "data-name": "Path 23434",
    d: "M6.843,28.868H5.753l.589-.917a.16.16,0,1,0-.269-.173l-.613.954-.612-.954a.16.16,0,0,0-.27.173l.589.917H4.076a.16.16,0,1,0,0,.321h1.09l-.589.917a.161.161,0,0,0,.049.222.155.155,0,0,0,.087.026.159.159,0,0,0,.135-.074l.612-.954.613.954a.157.157,0,0,0,.135.074.15.15,0,0,0,.086-.026.159.159,0,0,0,.049-.222l-.589-.917H6.843a.16.16,0,1,0,0-.321",
    transform: "translate(-0.445 -3.15)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23435",
    "data-name": "Path 23435",
    d: "M62.1,1.965H58.781a.193.193,0,1,1,0-.386H62.1a.193.193,0,1,1,0,.386",
    transform: "translate(-6.662 -0.18)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23436",
    "data-name": "Path 23436",
    d: "M61.439,3.184a.193.193,0,0,1-.162-.089L59.481.3A.192.192,0,1,1,59.8.09l1.8,2.8a.192.192,0,0,1-.058.266.182.182,0,0,1-.1.031",
    transform: "translate(-6.759 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23437",
    "data-name": "Path 23437",
    d: "M59.643,3.184a.182.182,0,0,1-.1-.031.192.192,0,0,1-.058-.266l1.8-2.8A.192.192,0,1,1,61.6.3l-1.8,2.8a.193.193,0,0,1-.162.089",
    transform: "translate(-6.76 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23438",
    "data-name": "Path 23438",
    d: "M23.046,50.927H19.722a.193.193,0,1,1,0-.386h3.324a.193.193,0,1,1,0,.386",
    transform: "translate(-2.22 -5.747)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23439",
    "data-name": "Path 23439",
    d: "M22.38,52.146a.193.193,0,0,1-.162-.089l-1.8-2.8a.192.192,0,1,1,.323-.208l1.8,2.8a.192.192,0,0,1-.058.266.182.182,0,0,1-.1.031",
    transform: "translate(-2.318 -5.567)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23440",
    "data-name": "Path 23440",
    d: "M20.583,52.146a.182.182,0,0,1-.1-.031.192.192,0,0,1-.058-.266l1.8-2.8a.192.192,0,1,1,.323.208l-1.8,2.8a.193.193,0,0,1-.162.089",
    transform: "translate(-2.318 -5.567)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23441",
    "data-name": "Path 23441",
    d: "M100.836,23.21H97.821a.175.175,0,0,1,0-.35h3.015a.175.175,0,0,1,0,.35",
    transform: "translate(-11.102 -2.599)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23442",
    "data-name": "Path 23442",
    d: "M100.233,24.316a.174.174,0,0,1-.147-.081L98.456,21.7a.175.175,0,0,1,.294-.189l1.629,2.537a.174.174,0,0,1-.053.241.165.165,0,0,1-.094.028",
    transform: "translate(-11.191 -2.436)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23443",
    "data-name": "Path 23443",
    d: "M98.6,24.316a.165.165,0,0,1-.094-.028.174.174,0,0,1-.053-.241l1.629-2.537a.175.175,0,0,1,.294.189l-1.629,2.537a.174.174,0,0,1-.147.081",
    transform: "translate(-11.191 -2.436)",
    fill: "#ff3d00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingwentwrong);
export default __webpack_public_path__ + "static/media/somethingwentwrong.bc239be742b0287463934d5cbdfa37e1.svg";
export { ForwardRef as ReactComponent };